import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { KeycloakService, KeycloakBearerInterceptor } from 'keycloak-angular';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from '../environment/environment'
import { HttpErrorInterceptorService } from './shared/services/httperror-interceptor.service';
import { CustomIconsService } from './shared/services/custom-icons.service';


export function initializeKeycloak(keycloakService: KeycloakService) {
  return () =>
    keycloakService.init({
      config: environment.keycloakConfig,
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: true,
      },
      loadUserProfileAtStartUp: true,
    });
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    {
      provide:HTTP_INTERCEPTORS,
      useClass:HttpErrorInterceptorService,
      multi:true
    },
    CustomIconsService,
    provideHttpClient(
      withInterceptorsFromDi()
    ),
  ]
};
